import App from './App.svelte';
const hideChat = () => {
    window.LiveChatWidget.call("hide");
};
const app = new App({
    target: document.body,
    props: {
        name: 'world'
    }
});
export default app;
